import {Component, ElementRef, EventEmitter, HostListener, Output} from '@angular/core';

@Component({
  selector: 'app-role-context-menu',
  templateUrl: './role-context-menu.component.html',
  styleUrls: ['./role-context-menu.component.scss']
})
export class RoleContextMenuComponent {

  @Output() isOpenModalDeleteRole: EventEmitter<void> = new EventEmitter<void>()

  isOpenMenu = false

  constructor(
    private elem: ElementRef
  ) {
  }

  @HostListener('document:click', ['$event'])
  DocumentClick(event: Event) {
    if (!this.elem.nativeElement.contains(event.target)) {
      this.isOpenMenu = false
    }
  }

  openMenu() {
    this.isOpenMenu = !this.isOpenMenu
  }

  openModalEditRole() {

  }

  openModalDeleteRole() {
    this.isOpenMenu = false
    this.isOpenModalDeleteRole.emit()
  }
}
